require([
    'services',
    'jquery',
    'ch_modal_window',
    'ch_header',
    'ch_semantic_responsive'
], function () {
    $('.js-sub-categories').on('click', function(e) {
        var me = this;
        ga(
            'send',
            'event',
            'New category page - ' + CH.GA.page,
            'Subcategory image block clicked',
            $(me).index() + 1,
            { nonInteraction: false }
        );
    });

    $('.button-block a.button').on('click', function(e) {
        var me = this;
        ga(
            'send',
            'event',
            'New category page - ' + CH.GA.page,
            'Button clicked',
            $(me).text(),
            { nonInteraction: false }
        );
    });

    const scriptTag = document.createElement('script');
    scriptTag.type = 'application/ld+json';

    // Get rich snippets for the page
    $.ajax({
        type: 'GET',
        url: '/course/filter/get-rich-snippets',
        data: {
            courseIds: CH.courseIds
        },
        dataType: 'html',
        success: function (html) {
            scriptTag.innerHTML = html;
            document.head.appendChild(scriptTag);
        },
    });
});
